export default __webpack_public_path__ + "static/media/ntex_updated.6fe178a4.svg";